import i18next from "i18next";
import {
  CtaBanner,
  CtaButton,
  CtaText,
  CtaTitle,
  Hero,
  HeroSubtitle,
  HeroTitle,
  SectionTitle,
  StatCard,
  StatLabel,
  StatNumber,
  StatsGrid,
  TextBlock,
  TwoColSection,
  ValueCard,
  ValueIcon,
  ValueText,
  ValuesGrid,
  ValueTitle,
  Wrapper,
} from "./style";

export const AboutComponent = () => {
  const { t } = i18next;

  return (
    <Wrapper>
      <Hero>
        <HeroTitle>
          {t("about_hero_title_1")} <span>Dushanbe24</span>
        </HeroTitle>
        <HeroSubtitle>{t("about_hero_subtitle")}</HeroSubtitle>
      </Hero>

      <StatsGrid>
        <StatCard>
          <StatNumber>2011</StatNumber>
          <StatLabel>{t("about_stat_founded")}</StatLabel>
        </StatCard>
        <StatCard>
          <StatNumber>50 000+</StatNumber>
          <StatLabel>{t("about_stat_customers")}</StatLabel>
        </StatCard>
        <StatCard>
          <StatNumber>100+</StatNumber>
          <StatLabel>{t("about_stat_airlines")}</StatLabel>
        </StatCard>
        <StatCard>
          <StatNumber>24/7</StatNumber>
          <StatLabel>{t("about_stat_support")}</StatLabel>
        </StatCard>
      </StatsGrid>

      <TwoColSection>
        <div>
          <SectionTitle>{t("about_mission_title")}</SectionTitle>
          <TextBlock>
            <p>{t("about_mission_text_1")}</p>
            <p>{t("about_mission_text_2")}</p>
          </TextBlock>
        </div>
        <div>
          <SectionTitle>{t("about_history_title")}</SectionTitle>
          <TextBlock>
            <p>{t("about_history_text_1")}</p>
            <p>{t("about_history_text_2")}</p>
            <p>{t("about_history_text_3")}</p>
          </TextBlock>
        </div>
      </TwoColSection>

      <SectionTitle>{t("about_values_title")}</SectionTitle>
      <ValuesGrid>
        <ValueCard>
          <ValueIcon>✈️</ValueIcon>
          <ValueTitle>{t("about_value_1_title")}</ValueTitle>
          <ValueText>{t("about_value_1_text")}</ValueText>
        </ValueCard>
        <ValueCard>
          <ValueIcon>🔒</ValueIcon>
          <ValueTitle>{t("about_value_2_title")}</ValueTitle>
          <ValueText>{t("about_value_2_text")}</ValueText>
        </ValueCard>
        <ValueCard>
          <ValueIcon>💬</ValueIcon>
          <ValueTitle>{t("about_value_3_title")}</ValueTitle>
          <ValueText>{t("about_value_3_text")}</ValueText>
        </ValueCard>
      </ValuesGrid>

      <CtaBanner>
        <CtaTitle>{t("about_cta_title")}</CtaTitle>
        <CtaText>{t("about_cta_text")}</CtaText>
        <CtaButton href="/">{t("about_cta_button")}</CtaButton>
      </CtaBanner>
    </Wrapper>
  );
};
